/**
 * Adzuki
 * destination_selection.js
 */

(function DestinationSelection($, Adzuki)
{
	"use strict";

	// selectors used for instantiating this must be unique.
	// unfortunately, there's no way to reliably get the selector used to create
	// a jQuery object, so i'm only tracking string-based selectors.
	var selectors = [];

	var destinationSelection = function DestinationSelection(el)
	{
		var self = this,
		    $input_field,
		    type,
		    uri,
			_selected    = {},
			_select_label = {};
		    // _insert_on_blur = false;

		// set labels per s&m
		_select_label['region']         = 'Cruise Region';
		_select_label['subregion']      = '  Cruise Subregion';
		_select_label['land-subregion'] = 'Land Region';
		_select_label['country']        = 'Country';
		_select_label['state']          = 'State';
		_select_label['city']           = 'City';

		try
		{
			// enforce 'new' operator to ensure 'this' points to this
			// instance, instead of the global window object.
			// in other Adzuki modules, this is enforced via a thrown Error,
			// but Adzuki.DestinationSelection is not generally assigned to a variable
			// like other Adzuki modules and it wouldn't make sense to throw
			// an Error because no methods are called on it directly,
			// so just return a new instance of this on runtime
			if ((this instanceof DestinationSelection) === false) {
				return new DestinationSelection(el);
			}

			this.$el        = null;
			this.$template  = null;
			this.$container = null;
			this.form_name  = 'destination';

			if (el instanceof jQuery) {
				this.$el = el;
			}
			else {
				if (selectors.indexOf(el) === -1) {
					selectors.push(el);
				}
				else {
					console.warn('[Adzuki.DestinationSelection] potential duplicate selector detected.');
				}

				this.$el = $(el);
			}

			if (!this.$el.length) {
				throw new Error('cannot find ' + el);
			}

			this.$template  = this.$el.find(".destination.template");
			this.$container = this.$el.find(".selected-destinations");
			$input_field    = this.$el.find('input[type="text"].search');

			if ($input_field.data("form-name")) {
				this.form_name = 'form_component_data[' + $input_field.data("form-name") + '][destination]';
			}

			if ($input_field.data('selected-destinations')) {
				_selected = $input_field.data('selected-destinations');
			}

			Adzuki.Typeahead(
				$input_field,
				function search(term, display, $self)
				{
					// _insert_on_blur = false;
					type = self.$el.find(".type").val();
					uri  = '/Searches/destination/'+type+'/'+term;

					if ($self.data('destination-required') !== undefined) {
						// destination is not required by default
						uri += '/1';
					}

					Adzuki.Ajax.get(uri)
					.then(function searchDisplay(response)
					{
						$self.removeClass('ajax-spinner');
						display(response);

						// in the case where a destination is not in our db,
						// we allow them to manually select it as a destination.
						// this tracks state so when people don't explicitly click
						// the "no results found, click to use x" we can do it automatically.
						// if (response.length === 1) {
						// 	if (response[0].status === 'insert_destination') {
						// 		_insert_on_blur = true;
						// 	}
						// }
					})
					.catch(function searchError()
					{
						$self.removeClass('ajax-spinner');
						display([{name: "Error searching for destinations."}]);
					});
				},
				function select(item, $self, context)
				{
					var type,
					    label,
					    label_type,
					    item_id;

					if (item.status) {
						if (item.status === 'insert_destination') {
							type    = 'manual_destination';
							item_id = item.destination;
							label   = item.destination;
						}
					}
					else if (item.id === undefined) {
						$self.val('');
						return;
					}
					else {
						item_id    = item.id;
						type       = item.type.toLowerCase().replace(/\s/g, '-');
						type       = type.replace('_', ' ');
						label_type = _select_label[item.type];
						label      = '<b>' + label_type + ":</b> " + item.name;
					}

					if (_selected[type] === undefined) {
						_selected[type] = [];
					}

					_selected[type].push(item_id);

					// setTimeout(function clearDestinationSearch() {
						$self.val('');
					// }, 100);
					// _insert_on_blur = false;
					self._addDestinationLabel(item_id, label, type);
				},
				function template(item) {
					var val = item.name;

					if (type === 'all' && typeof item.type !== 'undefined') {
						val = _select_label[item.type] + ': ' + val;
						// val = item.type.charAt(0).toUpperCase()+item.type.slice(1) + ': '+val;
						// val = val.replace('-', ' ');
						// val = val.replace('_', ' ');
						// val = Adzuki.String.ucwords(val);
					}

					return val;
				},
				function matcher(item) {
					if ($.inArray(item.id, _selected[item.type]) > -1) {
						return false;
					}

					return true;
				}
			);

			this.$el.on('click', '.remove', function remove() {
				var $self = $(this),
				    $input,
				    type,
				    // extract the type from the input name
				    type_regex = self.form_name.replace(/([\[\]])/g, "\\$1")+"(?:\\]?)\\[([\\w\\-]+)\\]";

				// remove destination from internal tracking
				$input = $self.siblings('input');
				type   = $input.prop('name').match(type_regex)[1];

				if (_selected[type] !== undefined) {
					_selected[type].splice(_selected[type].indexOf($input.val()), 1);
				}

				$self.parents('.destination').remove();

				if (self.$el.find('.destination').length <= 2) {
					self.$container.addClass('hidden');
					$input_field.trigger('adz.destinations.empty');
				}
			});

			this.$el.on('click', '.remove-all', function removeAll() {
				$(this).parents('.destinations')
				     .find('.destination')
				     .not('#remove-all')
				     .not('.template')
				     .remove();

				_selected = {};

				if (self.$el.find('.destination').length <= 2) {
					self.$container.addClass('hidden');
					$input_field.trigger('adz.destinations.empty');
				}
			});

			this.$el.on('blur', 'input[type="text"].search', function selectOnBlur() {
				$(this).val('');
				// var $self = $(this),
				//     destination = $self.val();

				// setTimeout(function waitToSelectOnBlur() {
				// 	if (_insert_on_blur) {
				// 		_insert_on_blur = false;
				// 		self._addDestinationLabel(destination, destination, 'manual_destination');
				// 		$self.val('');
				// 	}
				// }, 100);
			});
		}
		catch (err) {
			console.log('[Adzuki.DestinationSelection]', err);
		}
	};

	destinationSelection.prototype._addDestinationLabel = function _addDestinationLabel(id, label, type) {
		var $destination = this.$template.clone();
		$destination.removeClass('template');
		$destination.find('input').val(id).attr('name', this.form_name + '['+type+'][]');
		$destination.find('.title').html(label);
		$destination.appendTo(this.$container.find('.destinations'));

		if (this.$container.hasClass('hidden')) {
			this.$container.removeClass('hidden');
		}
	};

	Adzuki.DestinationSelection = destinationSelection;
}(jQuery, window.Adzuki || {}));
